import React from "react";

import { Box, Flex, Icon, Text } from "@chakra-ui/react";

interface CctvStatsProps {
    icon: any;
    label: string;
    value: number | string;
    color?: string;
}

const CctvStats: React.FC<CctvStatsProps> = ({ icon, label, value, color = "blue.500" }) => {
    return (
        <Box  m={4}>
            <Flex
                bg="white"
                p={4}
                align="center"
                gap={4}
                minW="150px"
                border="1px solid" borderColor="gray.200" borderRadius="lg"
            >
                <Flex
                    bg={`${color.split(".")[0]}.50`}
                    p={3}
                    borderRadius="md"
                    align="center"
                    justify="center"
                >
                    <Icon as={icon} boxSize={6} color={color} />
                </Flex>
                <Box>
                    <Text fontSize="sm" color="gray.600">
                        {label}
                    </Text>
                    <Text fontSize="2xl" fontWeight="bold">
                        {value}
                    </Text>
                </Box>
            </Flex>
        </Box>
    );
};

export default CctvStats;
